import React from "react";
import img2 from "../../../../../../assets/images/AISummit/aicopilot1.jpg";
import CustomButton from "../../../../../../shared_components/CustomButton";
const EventsVarieties = () => {
    const cards = [
        {
            id: 1,
            title: "Hands-on workshops and training",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat."
        },
        {
            id: 2,
            title: "Hackathons and community meetups",
            desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat."
        },

    ]
    return (
        <section className="row mx-0 align-items-center justify-content-center my-5">
            <div className="col-12 col-md-10 px-0">
                <div className="row mx-0 d-flex align-items-center justify-content-center py-5">
                    <div className="col-12 col-md-6 px-0">
                        <div className="col-12 " >
                            <div className="fw-bold p-3 m-3 bg-card border-card">
                                <h4 className="fs-24">Expert classes and masterclasses</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam libero vitae erat</p>
                            </div>
                        </div>
                        {cards.map((item, id) => (
                            <div className="col-12" key={id}>
                                <div className="p-3 m-3">
                                    <h4 className="fs-24">{item.title}</h4>
                                    <p>{item.desc}</p>
                                </div>
                            </div>
                        )
                        )
                        }
                    </div>
                    <div className="col-12 col-md-6">
                        <img
                            src={img2}
                            alt="Community Event"
                            className="img-fluid"
                        />

                    </div>
                </div>
            </div>
        </section>
    );
};

export default EventsVarieties;
